import { StyleSheet } from 'react-native';

export const createStyles = () =>
  StyleSheet.create({
    container: {
      flex: 1,
    },
    content: {
      flex: 1,
      justifyContent: 'center',
      padding: 20,
      width: '100%',
      maxWidth: 480,
      alignSelf: 'center',
    },
    logoContainer: {
      alignItems: 'center',
      marginBottom: 24,
    },
    logoImage: {
      width: 72,
      height: 72,
      borderRadius: 16,
    },
    title: {
      fontSize: 32,
      fontWeight: 'bold',
      marginBottom: 8,
    },
    subtitle: {
      fontSize: 16,
      marginBottom: 40,
      lineHeight: 22,
    },
    form: {
      width: '100%',
    },
    backButton: {
      alignItems: 'center',
    },
    backButtonText: {
      fontSize: 14,
      fontWeight: '600',
    },
  });
